<template>
  <section>
    <Feature :title="$t('AVERAGE_PURCHASE_PRICE_MAINTAIN')" :iconClass="'fa-money'">
      <FormRow :fieldNameArr="[$t('PLANT_CODE'), $t('DELTA_PN'), $t('VALID_FROM'), $t('VALID_TO'), $t('LOG')]">
        <Select filterable v-model="plantCode" style="width: 200px" slot="a">
          <Option v-for="(item, index) in plantList" :value="item" :key="index">{{ item }}</Option>
        </Select>
        <Input v-model="deltaPartNo" :maxlength="100" v-upper-case slot="b" />
        <DatePicker v-model="validFrom" type="date" format="yyyy-MM-dd" :placeholder="$t('CHOOSE') + $t('VALID_FROM')"
          slot="c"></DatePicker>
        <DatePicker v-model="validTo" type="date" format="yyyy-MM-dd" :placeholder="$t('CHOOSE') + $t('VALID_TO')"
          slot="d"></DatePicker>
        <i-switch v-model="isLog" slot="e"></i-switch>
      </FormRow>
      <ButtonRow>
        <Button type="primary" @click="search" slot="0">{{ $t('COMMON_TEXT_SEARCH') }}</Button>
        <Button type="primary" @click="upload" slot="1">{{ $t('UPLOAD') }}</Button>
        <Button type="primary" @click="clear" slot="2">{{ $t('CLEAR') }}</Button>
      </ButtonRow>
      <Feature v-show="existedPriceList" :title="'Data'" :iconClass="'fa-pencil-square-o'">
        <Button type="primary" @click="download">{{ $t('DOWNLOAD') }}</Button>
        <TablePage :tableWidth="windowWidth" :columnsList="columnsList" :resultList="priceList" :pageObj="pageObj"
          @changePage="changePage"></TablePage>
      </Feature>
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="model"
        :title="$t('UPLOAD') + ' ' + $t('AVERAGE_PURCHASE_PRICE_MAINTAIN')">
        <FormRow :fieldNameArr="['STEP1']">
          <Button icon="md-cloud-download" type="success" slot="a" @click="downloadSample">{{ $t('DOWNLOAD') }}</Button>
        </FormRow>
        <I style="color: red">Please use excel file, and the first row is column description which will not upload to
          system. Please input your data from second row.</I>
        <FormRow :fieldNameArr="['STEP2: ' + $t('UPLOAD') + ' ' + $t('AVERAGE_PURCHASE_PRICE_MAINTAIN')]">
          <ExcelRead @getExcelData="getExcelData" @submitExcelData="submitExcelData" slot="a">
          </ExcelRead>
        </FormRow>
      </Modal>
    </Feature>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import { DateToString, CheckFloat, CheckNotChinese, DateToNumber, DateValidationCheck } from "@/util/common"
import Swal from "sweetalert2/dist/sweetalert2.all.min.js"
import {
  Translate
} from "@/util/common"

export default {
  name: "AveragePurchasePrice",
  components: {
  },
  created() {
    let vueInstance = this
    if (vueInstance.getGroupCode()) {
      vueInstance.toggleLoading(true)
      vueInstance.$getPlantCode(vueInstance, vueInstance.getGroupCode().ecUuid).then(data => {
        vueInstance.toggleLoading(false)
        if (data) {
          data.forEach((plant) => {
            this.plantList.push(plant.objectKey)
          })
        } else {
          vueInstance.toggleLoading(false)
          AlertInfo(vueInstance, vueInstance.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
          })
          vueInstance.$router.push("/home")
        }
      })
    } else {
      vueInstance.$router.push("/home")
    }

    vueInstance.$getPlantCodeWhiteList(vueInstance, "PLANT").then(data => {
      if (data) {
        data.forEach((plant) => {
          this.plantWhiteList.push(plant)
        })
      }
    })
  },
  data() {
    return {
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      plantCode: '',
      plantList: [],
      plantWhiteList: [],
      deltaPartNo: '',
      validFrom: null,
      validTo: null,
      isLog: false,
      model: false,
      excelData: {},
      priceList: [],
      columnsList: [
        {
          title: this.$t('DELTA_PN'),
          key: "deltaPartNo",
          width: 180,
          align: "center",
        },
        {
          title: this.$t('SUB_CATEGORY_DESCRIPTION'),
          key: "subCategoryDescription",
          width: 250,
          align: "center",
        },
        {
          title: this.$t('PLANT_CODE'),
          key: "plantCode",
          width: 120,
          align: "center",
        },
        {
          title: this.$t('AVERAGE_PURCHASE_PRICE'),
          key: "price",
          width: 200,
          align: "center",
        },
        {
          title: this.$t('AVERAGE_PURCHASE_PRICE_CURRENCY'),
          key: "currency",
          width: 280,
          align: "center",
        },
        {
          title: this.$t('VALID_FROM'),
          key: "validFrom",
          width: 150,
          align: "center",
        },
        {
          title: this.$t('VALID_TO'),
          key: "validTo",
          width: 150,
          align: "center",
        },
        {
          title: this.$t('MATERIAL_TYPE'),
          key: "materialType",
          width: 130,
          align: "center",
        },
        {
          title: this.$t('CREATE_ACCOUNT'),
          key: "createdBy",
          width: 200,
          align: "center",
        },
        {
          title: this.$t('CREATE_DATE'),
          key: "created",
          width: 180,
          align: "center",
        },
        {
          title: this.$t('ENABLED'),
          width: 60,
          align: "center",
          render: (h, params) => {
            let value = params.row["enabled"] ? "YES" : "NO"
            return h("span", {}, value)
          },
          width: 110
        },
      ],
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getGroupCode", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    search(init) {
      const vueInstance = this
      if (init) {
        vueInstance.pageObj = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        }
      }
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .post('/average-purchase-price/search?sort=deltaPartNo&sort=plantCode&sort=currency&sort=validFrom&page='
          + vueInstance.pageObj.page + '&size=' + vueInstance.pageObj.pageSize, JSON.stringify(buildCriteria(vueInstance)))
        .then((response) => {
          vueInstance.toggleLoading(false)
          vueInstance.priceList = []
          if (response.data._embedded != undefined) {
            let data = response.data
            vueInstance.priceList = data._embedded.averagePurchasePriceResourceList
            vueInstance.pageObj = {
              "page": data.page.number + 1,
              "totalPage": data.page.totalPages,
              "totalCount": data.page.totalElements,
              "pageSize": data.page.size
            }
          } else {
            vueInstance.$Notice.success({
              title: Translate("COMMON_MESSAGE_INFO"),
              desc: Translate("COMMON_MESSAGE_INFO"),
              render: h => {
                return h('span', [
                  Translate("COMMON_TEXT_NOTHING")
                ])
              }
            });
          }
        })
        .catch(() => { })
    },
    clear() {
      this.plantCode = ''
      this.deltaPartNo = ''
      this.validFrom = null
      this.validTo = null
      this.isLog = false
    },
    upload() {
      this.model = true
    },
    downloadSample() {
      this.$downloadMasterAttachment(this, 'AveragePruchasePrice')
    },
    download() {
      this.$downloadExcel(this, "average-purchase-price", buildCriteria(this), "?sort=deltaPartNo&sort=plantCode&sort=currency&sort=validFrom")
    },
    getExcelData(excelData) {
      this.excelData = excelData.body
    },
    submitExcelData() {
      const vueInstance = this
      let uploadData = []
      let index = 2
      let errorMessage = ""
      vueInstance.excelData.forEach(e => {
        let data = {}
        data.price = e['Average Purchase Price']
        data.currency = e['Currency']
        data.deltaPartNo = e['Delta Part Number'].toString()
        data.materialType = e['Material Type(EE, ME, …)']
        data.plantCode = e['Plant']
        data.subCategoryDescription = e['Sub-Category Description']
        data.validFrom = e['Valid From'] == undefined ? "" : e['Valid From'].toString()
        data.validTo = e['Valid To'] == undefined ? "" : e['Valid To'].toString()
        data.index = index
        errorMessage = errorMessage + buildErrorMessage(index, data, vueInstance)
        uploadData.push(data)
        index++
      })
      if (errorMessage) {
        return AlertInfo(vueInstance, errorMessage).then(() => { })
      } else {
        let deplicateRow = []
        uploadData.forEach(data => {
          uploadData.forEach(checkData => {
            if (!deplicateRow.includes(checkData.index + "/" + data.index)
              && data.index != checkData.index && data.deltaPartNo == checkData.deltaPartNo && data.plantCode == checkData.plantCode
              && ((parseInt(data.validFrom) >= parseInt(checkData.validFrom) && parseInt(data.validFrom) <= parseInt(checkData.validTo))
                || (parseInt(data.validTo) >= parseInt(checkData.validFrom) && parseInt(data.validFrom) <= parseInt(checkData.validTo)))) {
              errorMessage = errorMessage + "Row " + data.index + " and Row " + checkData.index + ": " + vueInstance.$t('DUPLICATE_RECORDS') + "<br>"
              deplicateRow.push(data.index + "/" + checkData.index)
            }
          })
        })
        if (errorMessage) {
          AlertInfo(vueInstance, errorMessage).then(() => { })
        } else {
          vueInstance.toggleLoading(true)
          vueInstance.$quotationHttp
            .post("/average-purchase-price/create", JSON.stringify(uploadData))
            .then((response) => {
              vueInstance.model = false
              vueInstance.toggleLoading(false)
              vueInstance.search(true)
            })
            .catch(() => { })
        }
      }
    }
  },
  computed: {
    groupCode() {
      return this.getGroupCode() != null ? this.getGroupCode().ecUuid : null
    },
    existedPriceList() {
      return this.priceList.length > 0
    },
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  },
  watch: {
    plantCode: {
      handler() {
        this.priceList = []
      },
      immediate: true
    },
    deltaPartNo: {
      handler() {
        this.priceList = []
      },
      immediate: true
    },
    validFrom: {
      handler() {
        this.priceList = []
      },
      immediate: true
    },
    validTo: {
      handler() {
        this.priceList = []
      },
      immediate: true
    }
  }
}

function buildCriteria(vueInstance) {
  return {
    "plantCodes": vueInstance.plantCode ? [vueInstance.plantCode] : vueInstance.plantList,
    "deltaPartNo": vueInstance.deltaPartNo,
    "validFrom": vueInstance.validFrom != "" && vueInstance.validFrom != null ? DateToString(vueInstance.validFrom, "-") : null,
    "validTo": vueInstance.validTo != "" && vueInstance.validTo != null ? DateToString(vueInstance.validTo, "-") : null,
    "enabled": !vueInstance.isLog
  }
}

function buildErrorMessage(index, data, vueInstance) {
  let errorMessage = ""

  if (!data.price) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('AVERAGE_PURCHASE_PRICE') + vueInstance.$t('IS_REQUIRED') + "<br>"
  } else if (!CheckFloat(data.price)) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('AVERAGE_PURCHASE_PRICE') + vueInstance.$t('MUST_BE_NUMBER') + "<br>"
  } else if (data.price.length > 6) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('AVERAGE_PURCHASE_PRICE') + vueInstance.$t('ONLY_SIX_DECIMAL') + "<br>"
  }

  if (!data.currency) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('AVERAGE_PURCHASE_PRICE_CURRENCY') + vueInstance.$t('IS_REQUIRED') + "<br>"
  }
  if (!data.deltaPartNo) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('DELTA_PN') + vueInstance.$t('IS_REQUIRED') + "<br>"
  } else if (!CheckNotChinese(data.deltaPartNo)) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('PART_NO_VALID') + "<br>"
  }
  if (!data.materialType) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('MATERIAL_TYPE') + vueInstance.$t('IS_REQUIRED') + "<br>"
  }
  if (!data.plantCode) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('PLANT_CODE') + vueInstance.$t('IS_REQUIRED') + "<br>"
  } else if ((!vueInstance.plantList.includes(data.plantCode) && !vueInstance.plantList.includes("ALL")) || !vueInstance.plantWhiteList.includes(data.plantCode)) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('PLANT_CODE') + "(" + data.plantCode + ")" + vueInstance.$t('NO_PERMISSION_IN_AVERAGE_PURCHASE_PRICE') + "<br>"
  }
  if (!data.subCategoryDescription) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('SUB_CATEGORY_DESCRIPTION') + vueInstance.$t('IS_REQUIRED') + "<br>"
  }

  let checkValidFrom = 0
  if (!data.validFrom) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('VALID_FROM') + vueInstance.$t('IS_REQUIRED') + "<br>"
  } else if (!DateValidationCheck(data.validFrom)) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('VALID_FROM') + vueInstance.$t('FORMAT_ERROR') + "<br>"
  } else {
    checkValidFrom = parseInt(data.validFrom)
  }

  if (!data.validTo) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('VALID_TO') + vueInstance.$t('IS_REQUIRED') + "<br>"
  } else if (!DateValidationCheck(data.validTo)) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('VALID_TO') + vueInstance.$t('FORMAT_ERROR') + "<br>"
  } else if (checkValidFrom > parseInt(data.validTo)) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('VALID_FROM') + " > " + vueInstance.$t('VALID_TO') + "<br>"
  } else if (parseInt(data.validTo) < DateToNumber(new Date())) {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('VALID_TO') + " " + vueInstance.$t('MUST_AFTER_TODAY') + "<br>"
  }

  if (data.currency != "USD") {
    errorMessage = errorMessage + "Row " + index + ": " + vueInstance.$t('CURRENCY') + vueInstance.$t('MUST_USD') + "<br>"
  }

  return errorMessage
}
</script>

<style scoped></style>
